import { Draggable } from "react-beautiful-dnd";
import styles from "./Skill.module.css";
import Way from "../Way/Way";
import { useEffect, useState } from "react";
import { Button, Card } from "antd";
import { EyeInvisibleOutlined, EyeOutlined } from "@ant-design/icons";
import FlagMapper from "../../Util/FlagMapper";
const Skill = ({
  id,
  title,
  index,
  hide,
  active,
  ways,
  removeWayFromSkill,
  flag,
}) => {
  const [open, setOpen] = useState(false);
  let isValidskill = true;
  if (Array.isArray(ways) && ways.length === 0) {
    isValidskill = false;
  }

  return (
    <>
      {!hide && (
        <Draggable
          isDragDisabled={!isValidskill}
          draggableId={`${id}`}
          index={index}
        >
          {(provided) => (
            <div
              {...provided.draggableProps}
              {...provided.dragHandleProps}
              ref={provided.innerRef}
            >
              <Card
                bodyStyle={{ padding: 0 }}
                actions={
                  flag && [
                    <div className={styles.Flag}>
                      <div
                        className={styles.FlagCircle}
                        style={{
                          backgroundColor: FlagMapper(flag.type).circleColor,
                        }}
                      >
                        {FlagMapper(flag.type, { width: "1.25rem" }).icon}
                      </div>
                      {flag.title}
                    </div>,
                  ]
                }
                className={[
                  styles.Skill,
                  active ? styles.Active : null,
                  !(Array.isArray(ways) && ways.length > 0)
                    ? styles.Error
                    : null,
                ].join(" ")}
              >
                <h2 className={styles.Title}>{title} </h2>
                <div className={styles.Main}>
                  <div className={styles.Row}>
                    <h3 className={styles.WaysTitle}>روش‌های یادگیری</h3>
                    <Button
                      icon={!open ? <EyeOutlined /> : <EyeInvisibleOutlined />}
                      onClick={() => {
                        setOpen(!open);
                      }}
                    />
                  </div>
                  {open && (
                    <div className={styles.WaysContainer}>
                      {Array.isArray(ways) &&
                        ways.map((way) => {
                          return (
                            <Way
                              onDelete={() => {
                                removeWayFromSkill(way.id);
                              }}
                              {...way}
                            />
                          );
                        })}
                    </div>
                  )}
                </div>
              </Card>
            </div>
          )}
        </Draggable>
      )}
    </>
  );
};
export default Skill;
